import { iconClassNames } from '@fluentui/react-icons-northstar';

var getIconFillOrOutlineStyles = function getIconFillOrOutlineStyles(_ref) {
  var _ref2;

  var outline = _ref.outline;
  return _ref2 = {}, _ref2["& ." + iconClassNames.filled] = {
    display: outline ? 'none' : 'block'
  }, _ref2["& ." + iconClassNames.outline] = {
    display: outline ? 'block' : 'none'
  }, _ref2;
};

export default getIconFillOrOutlineStyles;
//# sourceMappingURL=getIconFillOrOutlineStyles.js.map
